import React from 'react'
import { useField } from 'formik'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Grid, Stack, Typography } from '@mui/material'
import Checkbox from 'src/Libs/inputs/formik/Checkbox'
import { TextField } from 'src/Libs/inputs/formik'

const IdlePeriodActivateForm: React.VFC = () => {
  const { t } = useCustomTranslation()
  const [activeField] = useField('isActive')
  return (
    <Box>
      <Typography variant={'body1'}>
        {t('systemSettings.smartFunctions.smartCharge.emsIdlePeriods.dialogs.toggleAll.activateView.description')}
      </Typography>
      <Grid container>
        <Grid item xs={12}>
          <Stack>
            <Checkbox
              name={'isActive'}
              label={t('systemSettings.smartFunctions.smartCharge.emsIdlePeriods.dialogs.toggleAll.activateView.applyValues')}
            />
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={6}>
              <TextField type={'time'} label={t('common.from')} name={'start'} InputLabelProps={{ shrink: true }} disabled={!activeField.value} />
            </Grid>
            <Grid item xs={6}>
              <TextField type={'time'} label={t('common.until')} name={'end'} InputLabelProps={{ shrink: true }} disabled={!activeField.value} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default IdlePeriodActivateForm
